import { List } from "immutable";
import React from "react";
import * as BS from "react-bootstrap";
import { connect } from "react-redux";
import { Link, RouteComponentProps, withRouter } from "react-router-dom";
import { push } from "react-router-redux";
import * as redux from "redux";
import * as Actions from "../../../actions";
import * as Comp from "../../../components";
import { Paths } from "../../../constants";
import * as Forms from "../../../forms";
import * as M from "../../../models";
import { Api } from "../../../services/Api";
import { AppState } from "../../../store";
import { PostJobForm } from "../../careerCenter";

const mapStateToProps = (state: AppState, ownProps: OwnProps | undefined): ConnectedState => {
    let hasMemberRole = false;
    if (state.auth.accessToken && state.auth.refreshToken) {
        const decodedToken =  new M.Auth.AuthTokenDecoded(state.auth.accessToken, state.auth.refreshToken);
        hasMemberRole = decodedToken.hasMemberRole();
    }

    return {
        api: new Api(state),
        countries: state.countries.countries,
        jobs: state.careerCenter.userJobs,
        userIsMember: hasMemberRole,
    };
};

const mapDispatchToProps = (dispatch: redux.Dispatch<AppState>): ConnectedDispatch => ({
    goto: (url: string) => dispatch(push(url)),
    notifyError: (message: string, icon?: string) => dispatch(Actions.Noti.notifyError(message, icon)),
    notifyInfo: (message: string, icon?: string) => dispatch(Actions.Noti.notifyInfo(message, icon)),
    notifySuccess: (message: string, icon?: string) => dispatch(Actions.Noti.notifySuccess(message, icon)),
});

type OwnProps = RouteComponentProps<{
    guid: string;
}> & {
};

interface ConnectedState {
    api: Api;
    countries: List<M.Country.Country>;
    jobs: List<M.CareerCenter.JobPost>;
    userIsMember: boolean;
}

interface ConnectedDispatch {
    goto: (url: string) => void;
    notifyError: (message: string, icon?: string) => void;
    notifyInfo: (message: string, icon?: string) => void;
    notifySuccess: (message: string, icon?: string) => void;
}

interface OwnState {
    errors: string[];
}

type CompinedProps = ConnectedState & ConnectedDispatch & OwnProps;

class EditJobComponent extends Comp.Base.BaseComponent<CompinedProps, OwnState> {

    private _form: PostJobForm | null;

    public constructor(props: any) {
        super(props);
        this.state = {
            errors: [],
            loading: false,
        };
    }

    public async componentDidMount() {
        this._isMounted = true;

        const guid = this.props.match.params.guid;
        if (!guid) {
            this.props.notifyError("Invalid job identifier");
            this.props.goto(Paths.User.CareerCenter.Jobs);
            return;
        }

        // get from state if available
        if (this.props.jobs.size && this._form) {
            const job = this.props.jobs.find((x) => x !== undefined && x.guid.toLowerCase() === guid.toLowerCase());
            if (job)
                this._form.setFormDataFromJob(job);
        }
        else
            this.toggleLoading(true);

        // load previously entered job
        const qp = { queryParams: { guid } };
        const result = await this.props.api.get<M.CareerCenter.JobPost>(Api.endpoints.users.careerCenter.job, qp);

        if (!this._isMounted)
            return;

        if (result.isSuccess && result.data) {
            if (this._form)
                this._form.setFormDataFromJob(result.data);
        }
        else {
            const errors =  M.Result.Result.errorsOrMessage(result);
            this.setState({ ...this.state, errors });
        }

        this.toggleLoading(false);
    }

    public componentWillUnmount() {
        this._isMounted = false;
    }

    public render() {
        let details = null;

        if (this.state.errors.length) {
            details = <BS.Alert bsStyle="warning">
                <h3>The requested job could not be retrieved.</h3>
                <ul>
                    {this.state.errors.map((e, i) => (<li key={i}>{e.toString()}</li>))}
                </ul>
            </BS.Alert>;
        }
        else {
            details = <PostJobForm
                api={this.props.api}
                cancelLink={Paths.User.CareerCenter.Jobs}
                countries={this.props.countries}
                onSubmit={(model, body) => this.onSubmit(model, body)}
                includeSubscribe={false}
                isUpdate
                userIsMember={this.props.userIsMember}
                ref={(ref) => this._form = ref}
            />;
        }

        return <Comp.Page.PublicPage pageTitle="Edit job post" style={{position: "relative", minHeight: "300px"}}>
            <Comp.Generic.LoadingSpinner show={this.state.loading} />

            <h1>
                <Link to={Paths.User.Account}>Your Account</Link> &raquo;{" "}
                <Link to={Paths.User.CareerCenter.Jobs}>Your Job Post{this.props.jobs.size === 1 ? "" : "s"}</Link> &raquo;{" "}
                Edit
            </h1>

            {details}
        </Comp.Page.PublicPage>;
    }

    private async onSubmit(model: Forms.CareerCenter.PostJobData, body: any) {
        if (!this._form)
            return;

        if (!this._form.state.modelChanged) {
            this.props.goto(Paths.User.CareerCenter.Jobs);
            return;
        }
        else {
            this._form.toggleProcessing(true);

            body.guid = this.props.match.params.guid;
            const result = await this.props.api.post<M.CareerCenter.JobPost>(Api.endpoints.users.careerCenter.job, { body: JSON.stringify(body) });

            if (!this._isMounted || !this._form)
                return;

            this._form.toggleProcessing(false);

            if (result.isSuccess && result.data) {
                this.props.notifySuccess(`Job <strong>${result.data.title}</strong> has been successfully updated.`);
                this.props.goto(Paths.User.CareerCenter.Jobs);
            }
            else {
                this._form.setFormErrors(M.Result.Result.errorsOrMessage(result), undefined, true);
            }
        }
    }
}

export const EditJob: React.ComponentClass<OwnProps> = connect(mapStateToProps, mapDispatchToProps)(withRouter(EditJobComponent) as any);



// WEBPACK FOOTER //
// ./src/containers/user/careerCenter/EditJob.tsx